import { render, staticRenderFns } from "./msg-item.vue?vue&type=template&id=5c6793de"
import script from "./msg-item.vue?vue&type=script&lang=js"
export * from "./msg-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports